export default "__VITE_ASSET__8f6a2e47__"